module.exports = __webpack_public_path__ + "static/media/6.67a9e560.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row4/6.wav
// module id = 81
// module chunks = 0